import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Plus, Search } from 'lucide-react';
import { useRegionStore } from '@/stores/regionStore';

interface RegionActionsProps {
  providerId: number;
  onAddRegion?: () => void;
}

export function RegionActions({ onAddRegion }: RegionActionsProps) {
  const { openCreateModal } = useRegionStore();
  
  const handleAddRegion = () => {
    if (onAddRegion) {
      onAddRegion();
    } else {
      openCreateModal();
    }
  };
  
  return (
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-bold">Regions</h2>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          asChild
        >
          <Link to="/regions/search">
            <Search className="w-4 h-4 mr-2" />
            Search by Zip Code
          </Link>
        </Button>
        <Button 
          onClick={handleAddRegion}
          size="sm"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add Region
        </Button>
      </div>
    </div>
  );
}
